class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', event => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') ||
        this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.progress = this.getAttribute('data-progress');
  }

  connectedCallback() {
    setTimeout(() => {
      this.querySelector('[data-progress-line]').style.width = this.progress;
    }, 100);
  }
}
customElements.define('progress-bar', ProgressBar);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);
    this.addEventListener(
      'change',
      this.debouncedOnChange.bind(this)
    );

    updateFreeShipping();
  }

  onChange(event) {
    if (event.target.name !== 'updates[]') return;

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return [
      {
        id: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        }`,
        section:
          document.getElementById('main-cart-items').dataset.id,
        selector: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        } cart-items`
      },
      {
        id: '#cart-counter',
        section: 'cart-counter',
        selector: '#shopify-section-cart-counter'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.classList.add('is-loading');

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(
        section => section.section
      ),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender()?.forEach(section => {
          const elementToReplace = document.querySelector(section.selector) || document.querySelector(section.id);


          if (elementToReplace) {
            if (!parsedState.errors) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          } else {
            console.error(`Element with selector ${section.selector} not found`);
          }
        });
        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();

        updateFreeShipping();
      })
      .finally(() => this.classList.remove('is-loading'));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .querySelectorAll(
          `[data-line-item-error][data-line="${line}"]`
        )
        .forEach(error => {
          error.innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.querySelector(`[id*="ProductQuantity-${line}"]`)
              .value
          );
        });
    }

    this.currentItemCount = itemCount;
  }
}

customElements.define('cart-items', CartItems);
// Universal safeguard for gift packaging in Sahara theme
document.addEventListener("DOMContentLoaded", function () {
  const giftName = "Gratis Weihnachtsgeschenkverpackung";
  const mainKeyword = "4711 Acqua Colonia";

  function checkCart() {
    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        let hasGift = false;
        let hasMain = false;
        let giftKey = null;

        cart.items.forEach(item => {
          if (item.title.includes(giftName)) {
            hasGift = true;
            giftKey = item.key;
          }
          if (item.title.includes(mainKeyword)) {
            hasMain = true;
          }
        });

        // Remove gift if no main product exists
        if (hasGift && !hasMain && giftKey) {
          fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              updates: {
                [giftKey]: 0
              }
            })
          }).then(() => {
            location.reload();
          });
        }
      });
  }

  // INITIAL LOAD
  checkCart();

  // Catch Sahara's AJAX cart changes
  document.addEventListener("click", function (e) {
    if (e.target.matches('[data-cart-remove]') ||
        e.target.matches('[data-update-cart]') ||
        e.target.closest('.cart__remove') ||
        e.target.closest('.cart-remove-button')) {
      setTimeout(checkCart, 500);
    }
  });

  // Catch quantity changes
  document.addEventListener("change", function (e) {
    if (e.target.matches('input[name="updates[]"]') ||
        e.target.matches('.cart-qty-input')) {
      setTimeout(checkCart, 500);
    }
  });

  // Catch potential custom Sahara events
  document.addEventListener("cart:refresh", checkCart);
  document.addEventListener("cart:updated", checkCart);

  // Fallback: re-check every few seconds (very light load)
  setInterval(checkCart, 3000);
});
